import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import AuthLayout from "../authLayout";
import {
  login,
  selectLoginStatus,
  selectstatus,
} from "../../../store/features/bidderSlice";

const BidderLogin = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();

  let loadingStatus = useSelector(selectstatus);
  let LoginStatus = useSelector(selectLoginStatus);

  const [error, setError] = React.useState("");
  const [showError, setShowError] = React.useState(false);

  const handleSubmit = async ({ userQuery, password }) => {
    if (!userQuery) {
      setError("Enter your user ID");
      setShowError(true);
      return;
    }
    if (!password) {
      setError("Enter your password");
      setShowError(true);
      return;
    }

    let resData = await dispatch(login({ userQuery, password })).unwrap();
    if (resData.statusCode === 200) {
      window.location.href = "/bidder/bidding";
    } else if (resData.statusCode === 400) {
      setError(resData.msg);
      setShowError(true);
    }
  };

  React.useEffect(() => {
    if (LoginStatus === "success") navigate("/bidder/bidding");
  }, [LoginStatus]);

  React.useEffect(() => {
    if (loadingStatus === "fulfilled") navigate("/bidder/bidding");
  }, [loadingStatus]);

  return (
    <AuthLayout
      role="bidder"
      blurb="Bid for your franchise and keep an eye on your purse."
      onSubmit={handleSubmit}
      error={error}
      showError={showError}
      setShowError={setShowError}
    />
  );
};

export default BidderLogin;
